<template lang="pug">
  .card.height-100
    .card-body
      .columns
        .column
          .text-bold.text-ellipsis {{ plan.title }}
          .text-ellipsis {{ plan.description }}
          .text-ellipsis
            | Status:
            span.text-bold(:class="status.class")  {{ status.label }}
          .text-ellipsis
            | Tipo de intervalo:
            span.text-bold  {{ plan.intervalType | planIntervalType }}
          .text-ellipsis
            | Preço:
            span.text-bold  {{ plan.price | currency('R$ ') }}
      small.label.label-primary.label-rounded(v-if="plan.monetizationForFiliations") Monetização ativada
      div Plano manual: #[b(:class="plan.isManualPayment ? 'text-success' : 'text-error'") {{ plan.isManualPayment | boolean }}]
      div Solicita endereço: #[b(:class="plan.requiresAddress ? 'text-success' : 'text-error'") {{ plan.requiresAddress | boolean }}]
    .card-footer
      .columns.align-center
        .column
          .text-small Adicionado em #[span.text-bold {{ plan.createdAt | toDate('DD/MM/YYYY') }}]
        .column.col-auto
          a.btn.btn-action.btn-sm.text-error.btn-link.tooltip(
            data-tooltip="Excluir"
            @click="$emit('remove', plan)"
          )
            i.fas.fa-trash-alt
          a.btn.btn-link.btn-sm.tooltip(:class="status.action.class" :data-tooltip="status.action.label" @click="$emit(status.action.event, plan)")
            i(:class="status.action.icon")
          router-link.btn.btn-action.btn-sm.btn-link.tooltip(
            :to="{ name: 'plans.edit', params: { id: plan.id } }"
            data-tooltip="Editar"
          )
            i.fas.fa-edit
          router-link.btn.btn-action.btn-sm.btn-link.tooltip(
            :to="{ name: 'plans.discountIntegrations', params: { id: plan.id } }"
            data-tooltip="Descontos por afiliação"
          )
            i.fas.fa-funnel-dollar
</template>

<script>
const status = {
  true: {
    label: 'Ativo',
    class: 'text-success',
    action: {
      event: 'deactivate',
      label: 'Inativar',
      icon: 'fas fa-lock',
      class: 'text-error',
    },
  },
  false: {
    label: 'Inativo',
    class: 'text-error',
    action: {
      event: 'activate',
      label: 'Ativar',
      icon: 'fas fa-lock-open',
      action: 'text-success',
    },
  },
}

export default {
  props: {
    plan: { type: Object, required: true },
  },
  computed: {
    status() {
      return status[this.plan.status]
    },
  },
}
</script>
